import { ModelFieldConfig } from '@/types/model.types';
import { DeviceType } from '@/app/platform/platform-shared/enum/device-type';
import { DeviceEntity } from '@/app/platform/platform-data/models/device.entity';

export const defaultDeviceFormConfig: ModelFieldConfig<DeviceEntity>[] = [
  {
    type: 'input',
    key: 'name',
    templateOptions: {
      label: 'Naam',
      required: true
    },
    focus: true
  },
  {
    type: 'input',
    key: 'pcName',
    templateOptions: {
      label: 'PC Naam',
      required: true
    }
  },
  {
    type: 'select',
    key: 'type',
    templateOptions: {
      required: true,
      label: 'Type',
      options: [
        {
          value: DeviceType.Heftruck,
          label: 'Heftruck'
        },
        {
          label: 'Pompkar',
          value: DeviceType.Pompkar
        },
        {
          value: DeviceType.EgiTerminal,
          label: 'Egi Terminal'
        },
        {
          value: DeviceType.HMI,
          label: 'HMI'
        },
        {
          value: DeviceType.Bureau,
          label: 'Bureau'
        }
      ]
    }
  },
  {
    key: 'defaultUserAccountId',
    type: 'user-select',
    templateOptions: {
      label: 'Default gebruiker'
    }
  }
];
